import { render, staticRenderFns } from "./RROrderList.vue?vue&type=template&id=5608129c&scoped=true&"
import script from "./RROrderList.vue?vue&type=script&lang=js&"
export * from "./RROrderList.vue?vue&type=script&lang=js&"
import style0 from "./RROrderList.vue?vue&type=style&index=0&id=5608129c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608129c",
  null
  
)

export default component.exports